import { SftpInfo, SftpInfoState } from '@core/services/sftp/sftp-info.model';
import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromRoot from '../../features.state';
import * as sftpsActions from './sftp-info.actions';

export interface AppState extends fromRoot.FeaturesState {
  sftps: SftpInfoState;
}

export const sftpInfoAdapter: EntityAdapter<SftpInfo> = createEntityAdapter<SftpInfo>();

export const defaultSftp: SftpInfoState = {
  ids: [],
  entities: {},
  selectedSftpInfoId: null,
  loading: false,
  loaded: false,
  error: ""
};

export const initialState = sftpInfoAdapter.getInitialState(defaultSftp);

export function SftpInfoReducer(
  state = initialState,
  action: sftpsActions.SftpInfoAction
): SftpInfoState {
  switch (action.type) {
    case sftpsActions.SftpInfoActionTypes.LOAD_SFTPINFOS_SUCCESS: {
      return sftpInfoAdapter.setAll(action.payload, {
        ...state,
        loading: false,
        loaded: true
      });
    }

    case sftpsActions.SftpInfoActionTypes.LOAD_SFTPINFOS_FAIL: {
      return {
        ...state,
        entities: {},
        loading: false,
        loaded: false,
        error: action.payload
      };
    }

    case sftpsActions.SftpInfoActionTypes.CREATE_SFTPINFO_SUCCESS: {
      return sftpInfoAdapter.addOne(action.payload, state);
    }

    case sftpsActions.SftpInfoActionTypes.CREATE_SFTPINFO_FAIL: {
      return {
        ...state,
        error: action.payload
      };
    }

    case sftpsActions.SftpInfoActionTypes.UPDATE_SFTPINFO_SUCCESS: {
      return sftpInfoAdapter.updateOne(action.payload, state);
    }

    case sftpsActions.SftpInfoActionTypes.UPDATE_SFTPINFO_FAIL: {
      return {
        ...state,
        error: action.payload
      };
    }
    default: {
      return state;
    }
  }
}

const getSftpFeatureState = createFeatureSelector<SftpInfoState>("sftp");

export const getSftpInfos = createSelector(
  getSftpFeatureState,
  sftpInfoAdapter.getSelectors().selectAll
);

export const getUsersLoading = createSelector(
  getSftpFeatureState,
  (state: SftpInfoState) => state.loading
);

export const getUsersLoaded = createSelector(
  getSftpFeatureState,
  (state: SftpInfoState) => state.loaded
);

export const getError = createSelector(
  getSftpFeatureState,
  (state: SftpInfoState) => state.error
);

export const getCurrentSftpId = createSelector(
  getSftpFeatureState,
  (state: SftpInfoState) => state.selectedSftpInfoId
);

export const getCurrentSftp = createSelector(
  getSftpFeatureState,
  getCurrentSftpId,
  state => state.entities[state.selectedSftpInfoId]
);
